import React from "react";
import { useMediaQuery } from "@mui/material";

function Section2() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <section>
      <div
        style={{
          height: "85vh",
          backgroundColor: "#6E07F3",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: isSmallScreen ? "90%" : "60%",
            flexDirection: "column",
            paddingBottom: isSmallScreen ? "5rem" : "10rem",
            textAlign: "center",
            padding: "1rem",
          }}
        >
          <h1
            style={{
              color: "white",
              fontFamily: "Font1",
              fontSize: isSmallScreen ? "24px" : "32px",
              fontWeight: 800,
              marginBottom: "10px",
              letterSpacing: "1px",
              textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
            }}
          >
            Hi, I'm Kunal. Nice to meet you.
          </h1>
          <h2
            style={{
              color: "white",
              fontFamily: "Font2",
              textAlign: "center",
              fontSize: isSmallScreen ? "16px" : "20px",
              fontWeight: 500,
              lineHeight: 1.5,
              letterSpacing: "1px",
              textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
            }}
          >
            Beginning my academic journey at IIIT Ranchi, I’ve embraced a path of
            continuous learning and growth. My curiosity drives me to explore new
            concepts, refine my technical skills, and broaden my understanding of
            the industry. As I evolve, my commitment to innovation and problem-solving
            remains steadfast.
          </h2>
        </div>
      </div>
    </section>
  );
}

export default Section2;
